export default "__VITE_ASSET__DZznsY32__"